class ShopperAccessibilityController {
    constructor(analyticsService, bootstrapService, shopperService) {
        this.analyticsService = analyticsService;
        this.shopperService = shopperService;
        this.bootstrap = bootstrapService;
    }

    $onInit() {
        this.analyticsPush();
    }

    setAccessibilityPreference() {
        this.shopperService.setPreferenceEnableAccessibility(this.shopperService.preferences.EnableAccessibleOptions);
    }

    analyticsPush() {
        if (this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.ShopperDetails) && this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.Trolley)) {
            this.shopper = this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.ShopperDetails) || {};
            this.address = this.shopper.Address;
            this.rewards = this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.Trolley).WowRewardsSummary;
            this.analyticsService.push({
                data: {
                    shopperDetails: this.shopper,
                    address: this.address,
                    rewards: this.rewards,
                },
                type: this.analyticsService.mapperTypes.account.shopperMyAccount,
            });
        }
    }
}

ShopperAccessibilityController.$inject = ['AnalyticsService', 'BootstrapService', 'ShopperService'];

const shopperAccessibilityComponentDefinition = {
    controller: ShopperAccessibilityController,
    template: require('./shopperaccessibility.component.html').trim(),
};

module.exports = {
    ShopperAccessibilityController,
    shopperAccessibilityComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/auth/shopper/shopperaccessibility.component.js